<template>
  <div class="pa-4">
    <div>
      <div class="mb-2" style="font-weight: 600; font-size: 23px">
        {{ type != 'edit' ? 'เพิ่มข้อมูลนัดลูกค้า' : 'แก้ไขข้อมูลนัดลูกค้า' }}
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('สมาชิก') }">
        <div>สมาชิก</div>
        <multiselect
          v-model="selectedCustomer"
          v-validate="'required'"
          :disabled="type == 'edit'"
          :options="customers"
          :searchable="true"
          placeholder=""
          name="สมาชิก"
          :custom-label="getFullname"
          :allow-empty="false"
          select-label
          selected-label
          deselect-label
          @select="onChangeCustomer"
        >
          <!-- <template slot="singleLabel" slot-scope="{ option }"
            >{{ option.name_th }} {{ option.surname_th }}
          </template>
          <template slot="option" slot-scope="{ option }"
            >{{ option.name_th }} {{ option.surname_th }}
          </template> -->
        </multiselect>
        <p v-if="errors.has('สมาชิก')" class="text-error">
          {{ errors.first('สมาชิก') }}
        </p>
      </div>
      <div class="mt-2">
        <v-layout row wrap>
          <v-flex xs12>
            <div>อีเมล</div>
            <div class="form-control" :class="{ 'has-error': errors.has('อีเมล') }">
              <input
                v-model="input.email"
                v-validate="'required|email'"
                :disabled="type == 'edit'"
                name="อีเมล"
                type="text"
                readonly
              />
              <p v-if="errors.has('อีเมล')" class="text-error">
                {{ errors.first('อีเมล') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12>
            <div>เบอร์โทร</div>
            <div class="form-control" :class="{ 'has-error': errors.has('เบอร์โทร') }">
              <input
                v-model="input.phone_number"
                v-validate="'required'"
                :disabled="type == 'edit'"
                name="เบอร์โทร"
                type="number"
                readonly
              />
              <p v-if="errors.has('เบอร์โทร')" class="text-error">
                {{ errors.first('เบอร์โทร') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('โครงการ') }">
              <div>โครงการ</div>
              <multiselect
                v-model="selectedProject"
                v-validate="'required'"
                :loading="projectloading"
                :options="projects"
                :disabled="!selectedCustomer || type == 'edit'"
                :searchable="false"
                placeholder="เลือกโครงการ"
                name="โครงการ"
                :allow-empty="false"
                select-label
                selected-label
                deselect-label
                @select="onChangeProject"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  >{{ option.project_name }}
                </template>
                <template slot="option" slot-scope="{ option }"
                  >{{ option.project_name }}
                </template>
              </multiselect>
              <p v-if="errors.has('โครงการ')" class="text-error">
                {{ errors.first('โครงการ') }}
              </p>
            </div>
          </v-flex>
          <v-flex v-if="selectedProject" xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('บ้านเลขที่') }">
              <div>บ้านเลขที่</div>
              <multiselect
                v-model="input.unit_no"
                v-validate="'required'"
                :loading="projectloading"
                :options="selectedProject.unit_list"
                :disabled="!selectedCustomer || !selectedProject || type == 'edit'"
                :searchable="false"
                placeholder="เลือกบ้านเลขที่"
                name="บ้านเลขที่"
                :allow-empty="false"
                select-label
                selected-label
                deselect-label
              >
              </multiselect>
              <p v-if="errors.has('บ้านเลขที่')" class="text-error">
                {{ errors.first('บ้านเลขที่') }}
              </p>
            </div>
          </v-flex>

          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('service') }">
              <div>Services</div>
              <multiselect
                v-model="input.service"
                v-validate="'required'"
                :options="servicelist"
                placeholder="Service"
                name="service"
                :allow-empty="false"
                select-label
                selected-label
                deselect-label
                group-values="service"
                group-label="category"
                :group-select="false"
                @select="selectService"
              >
              </multiselect>
              <p v-if="errors.has('service')" class="text-error">
                {{ errors.first('service') }}
              </p>
            </div>
          </v-flex>
          <template v-if="input.service">
            <v-flex xs12>
              <div>วันที่นัดหมาย</div>
              <div class="form-control" :class="{ 'has-error': errors.has('appointment_date') }">
                <DatepickerCustomDialog
                  :key="timestamp"
                  v-model="input.appointment_date"
                  :min="mindate"
                  :allowed-dates="allowedDates"
                  @input="onchangeDate($event, true)"
                >
                  <template #default="{ computedDate }">
                    <input
                      v-validate="'required'"
                      name="appointment_date"
                      data-vv-as="วันที่นัดหมาย"
                      :value="computedDate"
                      readonly
                      placeholder="DD/MM/YYYY"
                      type="text"
                    />
                  </template>
                </DatepickerCustomDialog>
                <p v-if="errors.has('appointment_date')" class="text-error">
                  {{ errors.first('appointment_date') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12>
              <div>เวลานัดหมาย</div>
              <div
                class="form-control"
                :class="{ 'has-error': errors.has('appointment_time_from') }"
              >
                <multiselect
                  v-model="appointment_time_from"
                  v-validate="'required'"
                  name="appointment_time_from"
                  data-vv-as="เวลานัดหมาย"
                  :options="timeList"
                  :allow-empty="false"
                  select-label
                  selected-label
                  deselect-label
                  label="text"
                  track-by="value"
                  :disabled="!input.appointment_date"
                />
                <!-- <CustomTimepicker v-model="input.appointment_time_from">
                  <input
                    name="appointment_time_from"
                    data-vv-as="เวลานัดหมาย - เริ่ม"
                    :value="input.appointment_time_from"
                    readonly
                    placeholder="00:00"
                    type="text"
                    v-validate="'required'"
                  />
                </CustomTimepicker> -->
                <p v-if="errors.has('appointment_time_from')" class="text-error">
                  {{ errors.first('appointment_time_from') }}
                </p>
              </div>
            </v-flex>
            <!-- <v-flex xs6 class="pl-2">
              <div>เวลานัดหมาย - สิ้นสุด</div>
              <div class="form-control">
                {{ currentEndTime }}
              </div>
            </v-flex> -->
          </template>

          <v-flex xs12>
            <div>point</div>
            <div class="form-control mb-4" :class="{ 'has-error': errors.has('point') }">
              {{ currentService ? currentService.points : 0 }} ({{ points }})
              <input v-model="input.point" v-validate="'required'" name="point" type="hidden" />
              <p v-if="errors.has('point')" class="text-error">
                {{ errors.first('point') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <div class="form-control" :class="{ 'has-error': errors.has('status') }">
              <div>Status</div>
              <multiselect
                v-model="input.status"
                v-validate="'required'"
                :options="['Pending', 'Approved', 'Done', 'Cancel By Admin']"
                :searchable="false"
                placeholder="Status"
                name="status"
                :allow-empty="false"
                select-label
                selected-label
                deselect-label
              >
              </multiselect>
              <p v-if="errors.has('status')" class="text-error">
                {{ errors.first('status') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="mb-3 form-control">
            <div>Remark</div>

            <textarea
              id="remark"
              v-model="input.remark"
              name="remark"
              style="width: 100%; height: 50px"
              :data-vv-as="$t('remark')"
              :placeholder="$t('Remark')"
            ></textarea>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="text-xs-center">
      <v-btn color="grey" outline @click="$emit('close')"> {{ $t('cancel') }}</v-btn>
      <v-btn :loading="loading" color="primary" depressed @click="saveData">
        {{ $t('Save') }}</v-btn
      >
    </div>

    <template v-if="input.history && input.history.length > 0">
      <v-divider class="mt-4" />

      <table class="zw-table fullwidth strip border-radius outline">
        <thead>
          <tr>
            <td>Admin</td>
            <td>Appointment date</td>
            <td>Appointment time</td>
            <td>Process</td>
            <td>Status</td>
            <td>Timestamp</td>
          </tr>
        </thead>
        <template v-for="history in input.history">
          <tr :key="history.timestamp">
            <td>{{ history.admin }}</td>
            <td>{{ history.appointment_date }}</td>
            <td>{{ history.appointment_time }}</td>
            <td>{{ history.process }}</td>
            <td>{{ history.status }}</td>
            <td>{{ history.timestamp }}</td>
          </tr>
        </template>
      </table>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    Multiselect,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  props: ['editdata', 'type', 'customers', 'value', 'services'],
  data() {
    return {
      loading: false,
      timeList: [],
      appointment_time_from: null,
      input: {
        custumer_name: '',
        appointment_date: '',
        appointment_time_from: '',
        appointment_time_to: '',
        phone_number: '',
        email: '',
        projects: '',
        point: 0,
        service: '',
        status: '',
        remark: ''
      },
      points: 0,
      projectloading: false,
      projects: [],
      selectedCustomer: '',
      selectedProject: '',
      mindate: moment().add('48', 'hours').format('YYYY-MM-DD'),
      availables: [],
      timestamp: moment().format('x')
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    currentService() {
      try {
        return this.services.find((el) => {
          return this.input.service == el.service
        })
      } catch (error) {}
      return null
    },
    servicelist() {
      try {
        return this.services
          .filter((el) => {
            return el != null && el != ''
          })
          .reduce((prev, curr) => {
            var index = prev.findIndex((el) => {
              return el.category == curr.category_service
            })
            if (index != -1) {
              prev[index].service.push(curr.service)
            } else {
              prev.push({
                category: curr.category_service,
                service: [curr.service]
              })
            }
            return prev
          }, [])
      } catch (error) {}
      return []
    }
  },
  async mounted() {
    if (this.type == 'edit') {
      this.input = cloneDeep(this.editdata)
      this.$set(
        this.input,
        'appointment_date',
        this.input.appointment_date
          ? moment(this.input.appointment_date).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD')
      )

      this.selectedCustomer = this.customers.find((el) => {
        return el.account_no == this.input.account_no
      })
      if (this.selectedCustomer) {
        await this.getProject(this.selectedCustomer.account_no)
        this.selectedProject = this.projects.find((el) => {
          return el.project_name == this.input.project_name
        })
      }

      this.onchangeDate(this.input.appointment_date)
      await this.$nextTick()
      this.appointment_time_from = this.timeList.find((el) => {
        return el.value == this.input.appointment_time_from
      })
    }
  },
  methods: {
    getFullname({ name_en, surname_en, name_th, surname_th }) {
      return `${name_en} ${surname_en} (${name_th} ${surname_th})`
    },
    onchangeDate(val, isChange = false) {
      let list = this.filterAvailableWeekday(
        moment.weekdays(true, moment(val).weekday()).toLowerCase()
      )
      this.errors.clear()

      if (isChange) this.$set(this.input, 'appointment_time_from', '')
      if (list.length > 0) {
        this.timeList = list
          .map((el) => {
            var end = moment(el.start, 'HH:mm')
              .add(parseInt(this.currentService.spend_time), 'minutes')
              .format('HH:mm')
            return {
              value: el.start,
              text: `${el.start} - ${end}`
            }
          })
          .sort((a, b) => {
            if (a.value > b.value) return 1
            else if (a.value < b.value) return -1
            else return 0
          })
      } else {
        this.timeList = []
      }
    },
    selectService(val) {
      this.input.appointment_date = null
      this.appointment_time_from = null
      this.errors.clear()

      var service = this.services.find((el) => {
        return val == el.service
      })
      if (service) {
        try {
          this.availables = JSON.parse(service.available)
        } catch (error) {
          this.availables = []
        }
      }
      this.timestamp = moment().format('x')
    },
    allowedDates(val) {
      try {
        return (
          this.filterAvailableWeekday(moment.weekdays(true, moment(val).weekday()).toLowerCase())
            .length > 0
        )
      } catch (error) {
        return false
      }
    },
    filterAvailableWeekday(val) {
      if (this.availables.length == 0) {
        var availables = []
        for (let index = 0; index < 24; index++) {
          availables.push({
            day: val,
            start: `${index.toString().padStart(2, '0')}:00`
          })
        }
        return availables
      }
      return this.availables.filter((el) => {
        return el.day.toLowerCase() == val || el.day == '' || el.day == null
      })
    },
    onChangeProject() {
      this.$set(this.input, 'unit_no', '')
    },
    async saveData() {
      if (
        this.currentService &&
        this.points - this.currentService.points < 0 &&
        this.input.status == 'Pending' &&
        this.input.service !== this.editdata.service
      ) {
        this.$swal.fire({ type: 'warning', title: 'คะแนนไม่เพียงพอ' })
      } else if (await this.$validator.validate()) {
        var timeto = moment(
          this.appointment_time_from ? this.appointment_time_from.value : '00:00',
          'HH:mm'
        )
          .add(this.currentService.spend_time, 'minutes')
          .format('HH:mm')

        var appointment = {
          ...this.input,
          project_name: this.selectedProject.project_name,
          custumer_name: this.selectedCustomer.name_en + ' ' + this.selectedCustomer.surname_en,
          custumer_name_en: this.selectedCustomer.name_en + ' ' + this.selectedCustomer.surname_en,
          custumer_name_th: this.selectedCustomer.name_th + ' ' + this.selectedCustomer.surname_th,
          account_no: this.selectedCustomer.account_no,
          point: this.currentService ? this.currentService.points : this.input.point,
          appointment_time_from: this.appointment_time_from ? this.appointment_time_from.value : '',
          appointment_time_to: timeto ? timeto : '',
          status: this.input.status == 'Cancel By Admin' ? 'Cancel By Admin' : this.input.status
        }
        this.loading = true

        this.$emit('saveAppointment', {
          appointment,
          oncomplete: () => {
            this.loading = false
          }
        })
      }
    },
    onChangeCustomer(item) {
      this.selectedCustomer = item
      this.$set(this.input, 'phone_number', item.mobile_1)
      this.$set(this.input, 'email', item.email_1)
      this.selectedProject = ''
      this.$set(this.input, 'unit_no', '')

      this.$forceUpdate()
      this.getProject(item.account_no)
    },
    getProject() {
      var data = {
        pageid: this.selectedBot.pageid,
        account_no: this.selectedCustomer.account_no
      }
      this.projectloading = true
      return new Promise((resolve, reject) => {
        api.getmjdcustomerprojectdashboard(data, (err, response) => {
          this.projectloading = false
          if (response.responsecode == 200) {
            this.projects = response.data2.reduce((prev, curr) => {
              var index = prev.findIndex((el) => {
                return el.project_name == curr.project_name
              })
              if (index != -1) {
                prev[index].unit_list.push(curr.unit_no)
              } else {
                prev.push({ ...curr, unit_list: [curr.unit_no] })
              }
              return prev
            }, [])

            this.points = response.total_points - parseInt(response.points_usage)
            resolve()
          } else {
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/EditAppointment.vue